import type { Case, CaseTask } from '../types';

function mergeTaskRecord(currentTask: CaseTask | null | undefined, updatedTask: CaseTask): CaseTask {
  return {
    ...(currentTask || {}),
    ...updatedTask
  };
}

export function mergeCaseTaskUpdate(
  caseRecord: Case | null | undefined,
  updatedTask: CaseTask | null | undefined
): Case | null {
  if (!caseRecord?.id || !updatedTask?.id) {
    return caseRecord || null;
  }

  let taskMatched = false;
  const nextTasks = Array.isArray(caseRecord.tasks)
    ? caseRecord.tasks.map(task => {
        if (task?.id !== updatedTask.id) {
          return task;
        }
        taskMatched = true;
        return mergeTaskRecord(task, updatedTask);
      })
    : [];

  if (!taskMatched) {
    nextTasks.push(updatedTask);
  }

  return {
    ...caseRecord,
    tasks: nextTasks,
    activeTask:
      caseRecord.activeTask?.id === updatedTask.id
        ? mergeTaskRecord(caseRecord.activeTask, updatedTask)
        : caseRecord.activeTask,
    displayTask:
      caseRecord.displayTask?.id === updatedTask.id
        ? mergeTaskRecord(caseRecord.displayTask, updatedTask)
        : caseRecord.displayTask
  };
}
